import { BrowserRouter } from "react-router-dom";


import './App.css';
import "primeicons/primeicons.css";
import "primereact/resources/themes/md-light-indigo/theme.css";
import "primereact/resources/primereact.css";

import AdminInterface from "./components/AdminInterface";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <AdminInterface />
      </div>
    </BrowserRouter>
  );
}

export default App;
